import { Decimal } from 'decimal.js';
const collator = new Intl.Collator(undefined, {
    sensitivity: 'base',
    numeric: true
});
export const compareNaturally = (a, b)=>collator.compare(a, b);
const compareByDeclaredOrder = (order, a, b)=>{
    const indexOf = (value)=>{
        const index = order.indexOf(value);
        return index === -1 ? order.length : index;
    };
    return indexOf(a) - indexOf(b);
};
const isAbsent = (value)=>value == null || value === '';
const firstOf = (value)=>Array.isArray(value) ? value[0] : value;
const isRecord = (value)=>typeof value === 'object' && value !== null;
const readString = (value, key)=>{
    const source = firstOf(value);
    return isRecord(source) && typeof source[key] === 'string' ? source[key] : '';
};
const readEpoch = (value)=>{
    if (value instanceof Date) return value.getTime();
    return new Date(String(value)).getTime();
};
const readNumeric = (value)=>{
    if (value instanceof Decimal) return value;
    if (isRecord(value) && value.charged != null) return readNumeric(value.charged);
    if (isRecord(value) && value.from instanceof Decimal) return value.from;
    return new Decimal(String(value));
};
const readOrder = (value)=>Array.isArray(value) ? value.filter((entry)=>typeof entry === 'string') : undefined;
const rankedBy = (order, read)=>order ? (a, b)=>compareByDeclaredOrder(order, read(a), read(b)) : (a, b)=>compareNaturally(read(a), read(b));
const asTagList = (value)=>Array.isArray(value) ? value.filter((entry)=>typeof entry === 'string') : [];
function schemaComparator(column) {
    const def = column.column;
    switch(def.type){
        case 'text':
        case 'indicators':
            return (a, b)=>compareNaturally(String(a), String(b));
        case 'date':
            return (a, b)=>readEpoch(a) - readEpoch(b);
        case 'money':
            return (a, b)=>readNumeric(a).comparedTo(readNumeric(b));
        case 'link':
            return (a, b)=>compareNaturally(readString(a, 'label'), readString(b, 'label'));
        case 'identity':
            return (a, b)=>compareNaturally(readString(a, 'name'), readString(b, 'name'));
        case 'badge':
            return rankedBy(readOrder(def.valueOrder), String);
        case 'tags':
            return (a, b)=>compareNaturally(asTagList(a).join(', '), asTagList(b).join(', '));
        default:
            return undefined;
    }
}
export function sortItems(param) {
    let { items, column, direction } = param;
    if (!column) return [
        ...items
    ];
    const compare = schemaComparator(column);
    if (!compare) return [
        ...items
    ];
    const readValue = valueReader(column);
    const sign = direction === 'asc' ? 1 : -1;
    return [
        ...items
    ].sort((rowA, rowB)=>{
        const a = readValue(rowA);
        const b = readValue(rowB);
        if (isAbsent(a) && isAbsent(b)) return 0;
        if (isAbsent(a)) return 1;
        if (isAbsent(b)) return -1;
        return sign * compare(a, b);
    });
}
function valueReader(column) {
    const def = column.column;
    const name = def.name;
    return (row)=>row[name];
}
